import {disclaimer, Disclaimer} from "./disclaimer/IInvestDisclaimerComponent";

export default angular.module("tfApp.iinvest", [])
                      .component(Disclaimer, disclaimer())
                      .name;
